export const HOTELS = [
  "Grand Tamanna",
  "Premier Tamanna",
  "Bizz Tamanna",
  "Executive Tamanna",
  "Shree Inn by Tamanna Hotels",
  "Imperial Tamanna",
];
export const CATEGORIES = ["Restaurant", "Room Stay", "Both"];
export const STATUSES = ["Pending", "Resolved"];
export const SENTIMENTS = ["Positive", "Neutral", "Negative"];

export const SMILEYS = [
  { value: 1, emoji: "😠", label: "Terrible", sub: "Angry", color: "#ef4444", ring: "ring-red-300", bg: "bg-red-50", text: "text-red-600" },
  { value: 2, emoji: "🙁", label: "Poor", sub: "Dissatisfied", color: "#f97316", ring: "ring-orange-300", bg: "bg-orange-50", text: "text-orange-600" },
  { value: 3, emoji: "😐", label: "Average", sub: "Neutral", color: "#eab308", ring: "ring-yellow-300", bg: "bg-yellow-50", text: "text-yellow-700" },
  { value: 4, emoji: "🙂", label: "Good", sub: "Satisfied", color: "#84cc16", ring: "ring-lime-300", bg: "bg-lime-50", text: "text-lime-700" },
  { value: 5, emoji: "😍", label: "Excellent", sub: "Extremely Happy", color: "#22c55e", ring: "ring-emerald-300", bg: "bg-emerald-50", text: "text-emerald-700" },
];

export const SENTIMENT_STYLE = {
  Positive: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Neutral: "bg-amber-50 text-amber-700 border-amber-200",
  Negative: "bg-red-50 text-red-700 border-red-200",
};

export const STATUS_STYLE = {
  Pending: "bg-red-50 text-red-700 border-red-200",
  Resolved: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export const COUNTRY_CODES = ["+91", "+971", "+966", "+974", "+65", "+44", "+1"];

export const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export function formatMobile(code, digits) {
  const d = digits.replace(/\D/g, "");
  if (code === "+91") return d.slice(0, 10).replace(/^(\d{5})(\d+)/, "$1 $2");
  return d.slice(0, 12).replace(/^(\d{3})(\d{3})(\d+)/, "$1 $2 $3");
}

export function fmtDate(iso) {
  if (!iso) return "";
  const [y, m, d] = iso.slice(0, 10).split("-");
  return new Date(+y, +m - 1, +d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}
